import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { io } from "socket.io-client";

// Change if your socket server is elsewhere:
const SOCKET_URL = "window.location.origin";

// Hardcoded admin password for now:
const ADMIN_PASSWORD = "ff";

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

function percent(current, max) {
  const c = Number(current);
  const m = Number(max);
  if (!Number.isFinite(c) || !Number.isFinite(m) || m <= 0) return 0;
  return clamp((c / m) * 100, 0, 100);
}

function Thermometer({ name, color, current, max, goal }) {
  const pct = percent(current, max);
  const goalPct = percent(goal, max); // goal as % of max

  return (
    <div style={styles.thermoCard}>
      <div style={styles.maxLabel}>{max}</div>

      <div style={styles.thermoWrap}>
        {/* Tube */}
        <div style={styles.tube}>
          {/* Goal line */}
          <div
            style={{
              ...styles.goalLine,
              bottom: `${goalPct}%`,
            }}
          />

          {/* Fill */}
          <div
            style={{
              ...styles.fill,
              height: `${pct}%`,
              background: color,
            }}
          />
        </div>

        {/* Bulb */}
        <div style={styles.bulbWrap}>
          <div
            style={{
              ...styles.bulb,
              background: color,
            }}
          />
          <div style={styles.bulbPct}>{Math.round(pct)}%</div>
        </div>
      </div>

      <div style={styles.valueRow}>
        <span style={styles.valueNum}>{current}</span>
        <span style={styles.valueSlash}>/</span>
        <span style={styles.valueNum}>{max}</span>
        <span style={styles.valuePct}>({Math.round(pct)}%)</span>
      </div>

      <div style={styles.name}>{name}</div>
    </div>
  );
}

export default function MegaGame() {
  const socketRef = useRef(null);
  const unlockedRef = useRef(false);

  const [thermometers, setThermometers] = useState([
    { id: 1, name: "Thermometer 1", color: "#22c55e", current: 0, max: 10, goal: 7  },
    { id: 2, name: "Thermometer 2", color: "#3b82f6", current: 0, max: 10, goal: 7  },
    { id: 3, name: "Thermometer 3", color: "#f97316", current: 0, max: 10, goal: 7  },
    { id: 4, name: "Thermometer 4", color: "#a855f7", current: 0, max: 10, goal: 7  },
  ]);

  const [showConfig, setShowConfig] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [pw, setPw] = useState("");
  const [pwErr, setPwErr] = useState("");
  const [draft, setDraft] = useState(thermometers);

  useEffect(() => {
    unlockedRef.current = unlocked;
  }, [unlocked]);


	useEffect(() => {
	const socket = io(); // same-origin
	  socketRef.current = socket;

	  socket.on("connect", () => {
		console.log("[MegaGame] socket connected:", socket.id);
	  });

	  socket.on("disconnect", (reason) => {
		console.log("[MegaGame] socket disconnected:", reason);
	  });

	  socket.on("thermometers:update", (data) => {
		setThermometers(data);
		setDraft((prev) => (unlockedRef.current ? prev : data));
	  });

  return () => {
    socket.off("thermometers:update");
    socket.disconnect();
    socketRef.current = null;
  };
}, []);

  function openConfig() {
    setShowConfig(true);
    setPw("");
    setPwErr("");
  }

  function closeConfig() {
    setShowConfig(false);
    setUnlocked(false);
    setPw("");
    setPwErr("");
    setDraft(thermometers);
  }

  function tryUnlock(e) {
    e.preventDefault();
    if (pw === ADMIN_PASSWORD) {
      setUnlocked(true);
      setPwErr("");
      setDraft(thermometers);
    } else {
      setPwErr("Wrong password.");
    }
  }

  function updateDraft(idx, patch) {
    setDraft((prev) => {
      const next = [...prev];
      next[idx] = { ...next[idx], ...patch };
      return next;
    });
  }
  
  

function pushUpdates() {
  const s = socketRef.current;
  console.log("[MegaGame] Update Live clicked. socket?", !!s, "connected?", s?.connected);

  if (!s || !s.connected) {
    console.warn("[MegaGame] Socket not connected; cannot push updates.");
    return;
  }

  s.emit("thermometers:set", draft);
}

  return (
    <div style={styles.page}>
      <div style={styles.headerRow}>
        <div>
          <h1 style={styles.h1}>Fantasial MegaGame Table Trackers</h1>
        </div>

        <div style={styles.headerButtons}>
          <button style={styles.btn} onClick={openConfig}>
            Configure
          </button>
          <Link to="/" style={styles.backLink}>
            ← Back to main app
          </Link>
        </div>
      </div>

      <div style={styles.grid}>
        {thermometers.map((t) => (
          <Thermometer key={t.id} {...t} />
        ))}
      </div>

      {/* Config Modal */}
      {showConfig && (
        <div style={styles.modalOverlay} onMouseDown={closeConfig}>
          <div style={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>Thermometer Configuration</div>
              <button style={styles.btnGhost} onClick={closeConfig}>
                ✕
              </button>
            </div>

            {!unlocked ? (
              <form onSubmit={tryUnlock} style={styles.lockForm}>
                <div style={styles.label}>Enter password</div>
                <input
                  type="password"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  style={styles.input}
                  autoFocus
                />
                {pwErr && <div style={styles.err}>{pwErr}</div>}
                <div style={styles.row}>
                  <button type="submit" style={styles.btnPrimary}>
                    Unlock
                  </button>
                  <button type="button" style={styles.btn} onClick={closeConfig}>
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              <>
                <div style={styles.note}>
                  Changes are live for everyone as soon as you press <b>Update Live</b>.
                </div>

                <div style={styles.configGrid}>
                  {draft.map((t, idx) => {
                    const pct = percent(Number(t.current), Number(t.max));
                    return (
                      <div key={t.id} style={styles.configCard}>
                        <div style={styles.configCardTitle}>Thermometer {t.id}</div>

                        <div style={styles.field}>
                          <div style={styles.label}>Name</div>
                          <input
                            value={t.name}
                            onChange={(e) => updateDraft(idx, { name: e.target.value })}
                            style={styles.input}
                          />
                        </div>

                        <div style={styles.field}>
                          <div style={styles.label}>Color</div>
                          <div style={styles.row}>
                            <input
                              type="color"
                              value={t.color}
                              onChange={(e) => updateDraft(idx, { color: e.target.value })}
                              style={styles.color}
                            />
                            <input
                              value={t.color}
                              onChange={(e) => updateDraft(idx, { color: e.target.value })}
                              style={styles.input}
                            />
                          </div>
                        </div>

                        <div style={styles.row}>
                          <div style={{ ...styles.field, flex: 1 }}>
                            <div style={styles.label}>Current</div>
                            <input
                              type="number"
                              value={t.current}
                              onChange={(e) =>
                                updateDraft(idx, { current: Number(e.target.value) })
                              }
                              style={styles.input}
                              min={0}
                            />
                          </div>

                          <div style={{ ...styles.field, flex: 1 }}>
                            <div style={styles.label}>Maximum</div>
                            <input
                              type="number"
                              value={t.max}
								onChange={(e) => {
								  const nextMax = Math.max(1, Number(e.target.value));
								  updateDraft(idx, {
									max: nextMax,
									goal: Math.min(Number(t.goal ?? 0), nextMax),
								  });
								}}
                              style={styles.input}
                              min={1}
                            />
                          </div>
						  <div style={styles.field}>
							  <div style={styles.label}>Goal</div>
							  <input
								type="number"
								value={t.goal ?? 0}
								onChange={(e) => updateDraft(idx, { goal: Number(e.target.value) })}
								style={styles.input}
								min={0}
							  />
							</div>
                        </div>

                        <div style={styles.previewRow}>
                          <div style={styles.previewBar}>
                            <div
                              style={{
                                ...styles.previewFill,
                                width: `${pct}%`,
                                background: t.color,
                              }}
                            />
                          </div>
                          <div style={styles.previewPct}>{Math.round(pct)}%</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div style={styles.modalFooter}>
                  <button style={styles.btnPrimary} onClick={pushUpdates}>
                    Update Live
                  </button>
                  <button style={styles.btn} onClick={() => setDraft(thermometers)}>
                    Reset to Live
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: {
    padding: 20,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
  },
  headerRow: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 18,
  },
  headerButtons: { display: "flex", gap: 12, alignItems: "center" },
  h1: { margin: 0, lineHeight: 1.1 },
  sub: { opacity: 0.75, marginTop: 6 },
  backLink: { textDecoration: "none" },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(200px, 1fr))",
    gap: 16,
    alignItems: "stretch",
  },

  thermoCard: {
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: 12,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    minHeight: 420,
  },
  maxLabel: { fontSize: 18, fontWeight: 700, opacity: 0.85 },
  thermoWrap: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 },
	tube: {
	  position: "relative",            // <-- add this
	  width: 52,
	  height: 450,
	  borderRadius: 999,
	  border: "2px solid rgba(0,0,0,0.2)",
	  overflow: "hidden",
	  display: "flex",
	  alignItems: "flex-end",
	  background: "rgba(0,0,0,0.03)",
	  clipPath: "polygon(0 0, 100% 0, 85% 100%, 15% 100%)",
	  marginBottom: "-50px",
	},
	goalLine: {
	  position: "absolute",
	  left: 0,
	  right: 0,
	  height: 3,
	  background: "black",
	  opacity: 0.9,
	  transform: "translateY(50%)",   // centers the line on the exact % point
	  pointerEvents: "none",
	  zIndex: 2,
	},
  fill: {
    width: "100%",
    transition: "height 220ms ease",
  },
  bulbWrap: { position: "relative", display: "flex", alignItems: "center", flexDirection: "column" },
  bulb: {
    width: 86,
    height: 86,
    borderRadius: "50%",
    border: "2px solid rgba(0,0,0,0.2)",
  },
  bulbPct: {
    position: "absolute",
    bottom: 10,
    fontWeight: 700,
    color: "rgba(0,0,0,0.65)",
  },

  valueRow: { display: "flex", gap: 6, alignItems: "baseline", opacity: 0.9 },
  valueNum: { fontWeight: 800, fontSize: 18 },
  valueSlash: { opacity: 0.6 },
  valuePct: { opacity: 0.7, fontSize: 14 },
  name: { marginTop: "auto", fontWeight: 700, textAlign: "center" },

  btn: {
    border: "1px solid rgba(0,0,0,0.2)",
    background: "white",
    borderRadius: 10,
    padding: "8px 12px",
    cursor: "pointer",
  },
  btnPrimary: {
    border: "1px solid rgba(0,0,0,0.2)",
    background: "black",
    color: "white",
    borderRadius: 10,
    padding: "9px 14px",
    cursor: "pointer",
  },
  btnGhost: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 18,
  },

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    zIndex: 50,
  },
  modal: {
    width: "min(980px, 96vw)",
    maxHeight: "88vh",
    overflow: "auto",
    background: "white",
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.18)",
    boxShadow: "0 18px 60px rgba(0,0,0,0.25)",
    padding: 16,
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  modalTitle: { fontSize: 18, fontWeight: 800 },
  modalFooter: { display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 14 },

  lockForm: { display: "flex", flexDirection: "column", gap: 10, paddingTop: 10 },
  label: { fontSize: 12, opacity: 0.7, marginBottom: 4 },
  input: {
    width: "100%",
    padding: "9px 10px",
    borderRadius: 10,
    border: "1px solid rgba(0,0,0,0.18)",
    outline: "none",
  },
  color: { width: 56, height: 40, padding: 0, border: "none", background: "transparent" },
  row: { display: "flex", gap: 10, alignItems: "center" },
  err: { color: "#b91c1c", fontWeight: 700, fontSize: 13 },

  note: { margin: "10px 0 14px 0", opacity: 0.8 },
  configGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(320px, 1fr))",
    gap: 12,
  },
  configCard: {
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: 12,
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  configCardTitle: { fontWeight: 900, marginBottom: 4 },
  field: { display: "flex", flexDirection: "column", gap: 6 },

  previewRow: { display: "flex", alignItems: "center", gap: 10, marginTop: 6 },
  previewBar: {
    flex: 1,
    height: 10,
    borderRadius: 999,
    background: "rgba(0,0,0,0.08)",
    overflow: "hidden",
    border: "1px solid rgba(0,0,0,0.1)",
  },
  previewFill: { height: "100%" },
  previewPct: { width: 52, textAlign: "right", fontWeight: 800, opacity: 0.75 },
};
